module.exports = __webpack_public_path__ + "img/PorQue_Desktop@1x.7d18e46.webp";